module.exports = __webpack_public_path__ + "static/media/instant.8b821cf3.png";